import useLocalStorage from './useLocalStorage'

export default () => {
  return useLocalStorage('campaign', {})
}
